/** ============================================================================
======== This file was automatically generated. Do not edit manually. =========
================================================================================ */

import type { DocumentTypeDecoration } from "@graphql-typed-document-node/core";
import type * as Types from "@magento-api-v2/__generated__/operation-types";

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>["__apiType"]>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const CustomerOrderPriceRangeFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(
  `
    fragment CustomerOrderPriceRangeFragment on PriceRange {
  minimum_price {
    regular_price {
      value
      currency
    }
    final_price {
      value
      currency
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
  maximum_price {
    discount {
      amount_off
      percent_off
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
}
    `,
  { fragmentName: "CustomerOrderPriceRangeFragment" }
) as unknown as TypedDocumentString<Types.MagentoApiCustomerOrderPriceRangeFragmentFragment, unknown>;
export const CustomerOrderProductFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(
  `
    fragment CustomerOrderProductFragment on ProductInterface {
  subscription
  subscription_format
  enable_order_quantity_limit
  order_quantity_limit
  description {
    html
  }
  short_description {
    html
  }
  categories {
    name
    uid
  }
  image {
    url
  }
  strength
  strength_details {
    name
    rating
  }
  price_range {
    ...CustomerOrderPriceRangeFragment
  }
}
    fragment CustomerOrderPriceRangeFragment on PriceRange {
  minimum_price {
    regular_price {
      value
      currency
    }
    final_price {
      value
      currency
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
  maximum_price {
    discount {
      amount_off
      percent_off
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
}`,
  { fragmentName: "CustomerOrderProductFragment" }
) as unknown as TypedDocumentString<Types.MagentoApiCustomerOrderProductFragmentFragment, unknown>;
export const CustomerOrderItemFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(
  `
    fragment CustomerOrderItemFragment on OrderItemInterface {
  id
  product_name
  product_sku
  product_type
  quantity_ordered
  trade_in
  row_total {
    currency
    value
  }
  row_total_incl_tax {
    currency
    value
  }
  product_sale_price {
    currency
    value
  }
  product_sale_price_incl_tax {
    currency
    value
  }
  gift_data {
    is_gift
    parent_gift_sku
    parent_gift_id
  }
  product {
    ...CustomerOrderProductFragment
  }
  ... on BundleOrderItem {
    bundle_options {
      id
      label
      values {
        id
        product_name
        quantity
        presentation_info {
          initial_price
          presentation_price
          product {
            tooltip_info
            small_image {
              label
              url
            }
          }
        }
      }
    }
  }
}
    fragment CustomerOrderProductFragment on ProductInterface {
  subscription
  subscription_format
  enable_order_quantity_limit
  order_quantity_limit
  description {
    html
  }
  short_description {
    html
  }
  categories {
    name
    uid
  }
  image {
    url
  }
  strength
  strength_details {
    name
    rating
  }
  price_range {
    ...CustomerOrderPriceRangeFragment
  }
}
fragment CustomerOrderPriceRangeFragment on PriceRange {
  minimum_price {
    regular_price {
      value
      currency
    }
    final_price {
      value
      currency
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
  maximum_price {
    discount {
      amount_off
      percent_off
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
}`,
  { fragmentName: "CustomerOrderItemFragment" }
) as unknown as TypedDocumentString<Types.MagentoApiCustomerOrderItemFragmentFragment, unknown>;
export const CustomerOrderBillingAddressFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(
  `
    fragment CustomerOrderBillingAddressFragment on OrderAddress {
  city
  country_code
  firstname
  lastname
  postcode
  street
  telephone
  administrative_area_level_2
  sublocality_level_2
  premise
  neighborhood
  landmark
  building_number
  district
  region
  short_address
}
    `,
  { fragmentName: "CustomerOrderBillingAddressFragment" }
) as unknown as TypedDocumentString<Types.MagentoApiCustomerOrderBillingAddressFragmentFragment, unknown>;
export const CustomerOrderShippingAddressFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(
  `
    fragment CustomerOrderShippingAddressFragment on OrderAddress {
  city
  country_code
  firstname
  lastname
  postcode
  street
  telephone
  pickup_information
  administrative_area_level_2
  sublocality_level_2
  premise
  neighborhood
  landmark
  building_number
  district
  region
  short_address
}
    `,
  { fragmentName: "CustomerOrderShippingAddressFragment" }
) as unknown as TypedDocumentString<Types.MagentoApiCustomerOrderShippingAddressFragmentFragment, unknown>;
export const CustomerOrderTotalFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(
  `
    fragment CustomerOrderTotalFragment on OrderTotal {
  discounts {
    amount {
      currency
      value
    }
    label
    coupon_code
  }
  grand_total {
    currency
    value
  }
  subtotal {
    currency
    value
  }
  subtotal_incl_tax {
    currency
    value
  }
  taxes {
    title
    rate
    amount {
      currency
      value
    }
  }
  total_shipping {
    currency
    value
  }
  total_refunded {
    currency
    value
  }
  total_tax {
    currency
    value
  }
}
    `,
  { fragmentName: "CustomerOrderTotalFragment" }
) as unknown as TypedDocumentString<Types.MagentoApiCustomerOrderTotalFragmentFragment, unknown>;
export const CustomerOrderFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(
  `
    fragment CustomerOrderFragment on CustomerOrder {
  id
  carrier
  number
  order_date
  shipping_method
  shipping_method_code
  status
  items {
    ...CustomerOrderItemFragment
  }
  payment_methods {
    type
    name
    additional_data {
      name
      value
    }
  }
  additional_attributes {
    attribute_code
    value
  }
  billing_address {
    ...CustomerOrderBillingAddressFragment
  }
  shipping_address {
    ...CustomerOrderShippingAddressFragment
  }
  loyalty_info {
    loyalty_discount_amount
    loyalty_discount_points
    loyalty_discount_uuid
  }
  invoices {
    url
  }
  total {
    ...CustomerOrderTotalFragment
  }
  total_including_trial {
    total {
      currency
      value
    }
    total_incl_tax {
      currency
      value
    }
    tax {
      currency
      value
    }
  }
  total_after_trial {
    total {
      currency
      value
    }
    total_incl_tax {
      currency
      value
    }
    tax {
      currency
      value
    }
  }
}
    fragment CustomerOrderItemFragment on OrderItemInterface {
  id
  product_name
  product_sku
  product_type
  quantity_ordered
  trade_in
  row_total {
    currency
    value
  }
  row_total_incl_tax {
    currency
    value
  }
  product_sale_price {
    currency
    value
  }
  product_sale_price_incl_tax {
    currency
    value
  }
  gift_data {
    is_gift
    parent_gift_sku
    parent_gift_id
  }
  product {
    ...CustomerOrderProductFragment
  }
  ... on BundleOrderItem {
    bundle_options {
      id
      label
      values {
        id
        product_name
        quantity
        presentation_info {
          initial_price
          presentation_price
          product {
            tooltip_info
            small_image {
              label
              url
            }
          }
        }
      }
    }
  }
}
fragment CustomerOrderProductFragment on ProductInterface {
  subscription
  subscription_format
  enable_order_quantity_limit
  order_quantity_limit
  description {
    html
  }
  short_description {
    html
  }
  categories {
    name
    uid
  }
  image {
    url
  }
  strength
  strength_details {
    name
    rating
  }
  price_range {
    ...CustomerOrderPriceRangeFragment
  }
}
fragment CustomerOrderPriceRangeFragment on PriceRange {
  minimum_price {
    regular_price {
      value
      currency
    }
    final_price {
      value
      currency
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
  maximum_price {
    discount {
      amount_off
      percent_off
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
}
fragment CustomerOrderBillingAddressFragment on OrderAddress {
  city
  country_code
  firstname
  lastname
  postcode
  street
  telephone
  administrative_area_level_2
  sublocality_level_2
  premise
  neighborhood
  landmark
  building_number
  district
  region
  short_address
}
fragment CustomerOrderShippingAddressFragment on OrderAddress {
  city
  country_code
  firstname
  lastname
  postcode
  street
  telephone
  pickup_information
  administrative_area_level_2
  sublocality_level_2
  premise
  neighborhood
  landmark
  building_number
  district
  region
  short_address
}
fragment CustomerOrderTotalFragment on OrderTotal {
  discounts {
    amount {
      currency
      value
    }
    label
    coupon_code
  }
  grand_total {
    currency
    value
  }
  subtotal {
    currency
    value
  }
  subtotal_incl_tax {
    currency
    value
  }
  taxes {
    title
    rate
    amount {
      currency
      value
    }
  }
  total_shipping {
    currency
    value
  }
  total_refunded {
    currency
    value
  }
  total_tax {
    currency
    value
  }
}`,
  { fragmentName: "CustomerOrderFragment" }
) as unknown as TypedDocumentString<Types.MagentoApiCustomerOrderFragmentFragment, unknown>;
export const AddBundleProductsToCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation addBundleProductsToCart($cartId: String!, $cartItems: [BundleProductCartItemInput!]!) {
  addBundleProductsToCart(input: {cart_id: $cartId, cart_items: $cartItems}) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiAddBundleProductsToCartMutationResponse,
  Types.MagentoApiAddBundleProductsToCartMutationVariables
>;
export const AddConfigurableProductsToCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation addConfigurableProductsToCart($cartId: String!, $sku: String!, $parentSku: String!, $quantity: Float!) {
  addConfigurableProductsToCart(
    input: {cart_id: $cartId, cart_items: [{parent_sku: $parentSku, data: {quantity: $quantity, sku: $sku}}]}
  ) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiAddConfigurableProductsToCartMutationResponse,
  Types.MagentoApiAddConfigurableProductsToCartMutationVariables
>;
export const AddProductsToCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation addProductsToCart($cartId: String!, $cartItems: [CartItemInput!]!) {
  addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiAddProductsToCartMutationResponse,
  Types.MagentoApiAddProductsToCartMutationVariables
>;
export const AddSimpleProductsToCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation addSimpleProductsToCart($cartId: String!, $cartItems: [SimpleProductCartItemInput!]!) {
  addSimpleProductsToCart(input: {cart_id: $cartId, cart_items: $cartItems}) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiAddSimpleProductsToCartMutationResponse,
  Types.MagentoApiAddSimpleProductsToCartMutationVariables
>;
export const ApplyCampaignToCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation applyCampaignToCart($cartId: String!, $campaign_uuid: String!) {
  applyCampaignToCart(input: {cart_id: $cartId, campaign_uuid: $campaign_uuid}) {
    cart {
      applied_campaign {
        loyalty_discount_uuid
        loyalty_discount_points
        loyalty_discount_amount
      }
      id
      is_virtual
      items {
        product {
          sku
        }
        quantity
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiApplyCampaignToCartMutationResponse,
  Types.MagentoApiApplyCampaignToCartMutationVariables
>;
export const ApplyCouponsToCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation applyCouponsToCart($cartId: String!, $couponCodes: [String!]!) {
  applyCouponsToCart(
    input: {cart_id: $cartId, coupon_codes: $couponCodes, type: REPLACE}
  ) {
    cart {
      id
      applied_coupons {
        code
        label
      }
      prices {
        discounts {
          amount {
            currency
            value
          }
          label
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiApplyCouponsToCartMutationResponse,
  Types.MagentoApiApplyCouponsToCartMutationVariables
>;
export const CancelOrderDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation cancelOrder($orderNumber: String!) {
  cancelorder(orderId: $orderNumber)
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiCancelOrderMutationResponse,
  Types.MagentoApiCancelOrderMutationVariables
>;
export const CreateEmptyCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation createEmptyCart {
  createEmptyCart
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiCreateEmptyCartMutationResponse,
  Types.MagentoApiCreateEmptyCartMutationVariables
>;
export const GetOrderStatusesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getOrderStatuses {
  getorderstatus {
    status_label
    status_value
    cancelable
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetOrderStatusesQueryResponse,
  Types.MagentoApiGetOrderStatusesQueryVariables
>;
export const MergeCartsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation mergeCarts($sourceCartId: String!, $destinationCartId: String!) {
  mergeCarts(
    source_cart_id: $sourceCartId
    destination_cart_id: $destinationCartId
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiMergeCartsMutationResponse,
  Types.MagentoApiMergeCartsMutationVariables
>;
export const PlaceOrderDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation placeOrder($cartId: String!, $additionalAttributes: [OrderAttributeInput]) {
  placeOrder(
    input: {cart_id: $cartId, additional_attributes: $additionalAttributes}
  ) {
    orderV2 {
      ...CustomerOrderFragment
    }
    errors {
      message
      code
    }
  }
}
    fragment CustomerOrderFragment on CustomerOrder {
  id
  carrier
  number
  order_date
  shipping_method
  shipping_method_code
  status
  items {
    ...CustomerOrderItemFragment
  }
  payment_methods {
    type
    name
    additional_data {
      name
      value
    }
  }
  additional_attributes {
    attribute_code
    value
  }
  billing_address {
    ...CustomerOrderBillingAddressFragment
  }
  shipping_address {
    ...CustomerOrderShippingAddressFragment
  }
  loyalty_info {
    loyalty_discount_amount
    loyalty_discount_points
    loyalty_discount_uuid
  }
  invoices {
    url
  }
  total {
    ...CustomerOrderTotalFragment
  }
  total_including_trial {
    total {
      currency
      value
    }
    total_incl_tax {
      currency
      value
    }
    tax {
      currency
      value
    }
  }
  total_after_trial {
    total {
      currency
      value
    }
    total_incl_tax {
      currency
      value
    }
    tax {
      currency
      value
    }
  }
}
fragment CustomerOrderItemFragment on OrderItemInterface {
  id
  product_name
  product_sku
  product_type
  quantity_ordered
  trade_in
  row_total {
    currency
    value
  }
  row_total_incl_tax {
    currency
    value
  }
  product_sale_price {
    currency
    value
  }
  product_sale_price_incl_tax {
    currency
    value
  }
  gift_data {
    is_gift
    parent_gift_sku
    parent_gift_id
  }
  product {
    ...CustomerOrderProductFragment
  }
  ... on BundleOrderItem {
    bundle_options {
      id
      label
      values {
        id
        product_name
        quantity
        presentation_info {
          initial_price
          presentation_price
          product {
            tooltip_info
            small_image {
              label
              url
            }
          }
        }
      }
    }
  }
}
fragment CustomerOrderProductFragment on ProductInterface {
  subscription
  subscription_format
  enable_order_quantity_limit
  order_quantity_limit
  description {
    html
  }
  short_description {
    html
  }
  categories {
    name
    uid
  }
  image {
    url
  }
  strength
  strength_details {
    name
    rating
  }
  price_range {
    ...CustomerOrderPriceRangeFragment
  }
}
fragment CustomerOrderPriceRangeFragment on PriceRange {
  minimum_price {
    regular_price {
      value
      currency
    }
    final_price {
      value
      currency
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
  maximum_price {
    discount {
      amount_off
      percent_off
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
}
fragment CustomerOrderBillingAddressFragment on OrderAddress {
  city
  country_code
  firstname
  lastname
  postcode
  street
  telephone
  administrative_area_level_2
  sublocality_level_2
  premise
  neighborhood
  landmark
  building_number
  district
  region
  short_address
}
fragment CustomerOrderShippingAddressFragment on OrderAddress {
  city
  country_code
  firstname
  lastname
  postcode
  street
  telephone
  pickup_information
  administrative_area_level_2
  sublocality_level_2
  premise
  neighborhood
  landmark
  building_number
  district
  region
  short_address
}
fragment CustomerOrderTotalFragment on OrderTotal {
  discounts {
    amount {
      currency
      value
    }
    label
    coupon_code
  }
  grand_total {
    currency
    value
  }
  subtotal {
    currency
    value
  }
  subtotal_incl_tax {
    currency
    value
  }
  taxes {
    title
    rate
    amount {
      currency
      value
    }
  }
  total_shipping {
    currency
    value
  }
  total_refunded {
    currency
    value
  }
  total_tax {
    currency
    value
  }
}`) as unknown as TypedDocumentString<
  Types.MagentoApiPlaceOrderMutationResponse,
  Types.MagentoApiPlaceOrderMutationVariables
>;
export const RemoveCampaignFromCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation removeCampaignFromCart($cartId: String!) {
  removeCampaignFromCart(input: {cart_id: $cartId}) {
    cart {
      applied_campaign {
        loyalty_discount_uuid
        loyalty_discount_points
        loyalty_discount_amount
      }
      id
      is_virtual
      items {
        product {
          sku
        }
        quantity
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiRemoveCampaignFromCartMutationResponse,
  Types.MagentoApiRemoveCampaignFromCartMutationVariables
>;
export const RemoveCouponsFromCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation removeCouponsFromCart($cartId: String!, $couponCodes: [String!]!) {
  removeCouponsFromCart(input: {cart_id: $cartId, coupon_codes: $couponCodes}) {
    cart {
      id
      applied_coupons {
        code
      }
      prices {
        discounts {
          amount {
            currency
            value
          }
          label
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiRemoveCouponsFromCartMutationResponse,
  Types.MagentoApiRemoveCouponsFromCartMutationVariables
>;
export const RemoveItemFromCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation removeItemFromCart($cartId: String!, $itemId: Int!) {
  removeItemFromCart(input: {cart_id: $cartId, cart_item_id: $itemId}) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiRemoveItemFromCartMutationResponse,
  Types.MagentoApiRemoveItemFromCartMutationVariables
>;
export const SetAdditionalAttributesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation setAdditionalAttributes($cartId: String!, $additionalAttributes: [QuoteAttributeInput!]!) {
  setAdditionalAttributes(
    input: {cart_id: $cartId, additional_attributes: $additionalAttributes}
  ) {
    errors {
      code
      message
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiSetAdditionalAttributesMutationResponse,
  Types.MagentoApiSetAdditionalAttributesMutationVariables
>;
export const SetAddressesOnCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation setAddressesOnCart($cartId: String!, $shipping_addresses: CartAddressInput!, $billing_address: CartAddressInput!) {
  setShippingAddressesOnCart(
    input: {cart_id: $cartId, shipping_addresses: [{address: $shipping_addresses}]}
  ) {
    cart {
      id
    }
  }
  setBillingAddressOnCart(
    input: {cart_id: $cartId, billing_address: {address: $billing_address}}
  ) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiSetAddressesOnCartMutationResponse,
  Types.MagentoApiSetAddressesOnCartMutationVariables
>;
export const SetBillingAddressOnCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation setBillingAddressOnCart($cartId: String!, $address: CartAddressInput!) {
  setBillingAddressOnCart(
    input: {cart_id: $cartId, billing_address: {address: $address}}
  ) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiSetBillingAddressOnCartMutationResponse,
  Types.MagentoApiSetBillingAddressOnCartMutationVariables
>;
export const SetBillingAddressOnCartByAddressIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation setBillingAddressOnCartByAddressId($cartId: String!, $customer_address_id: Int!) {
  setBillingAddressOnCart(
    input: {cart_id: $cartId, billing_address: {customer_address_id: $customer_address_id}}
  ) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiSetBillingAddressOnCartByAddressIdMutationResponse,
  Types.MagentoApiSetBillingAddressOnCartByAddressIdMutationVariables
>;
export const SetCheckoutFastFlowCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation setCheckoutFastFlowCart($cartId: String!, $shippingAddress: CartAddressInput!, $billingAddress: CartAddressInput!, $carrierCode: String!, $methodCode: String!) {
  setShippingAddressesOnCart(
    input: {cart_id: $cartId, shipping_addresses: [{address: $shippingAddress}]}
  ) {
    cart {
      id
    }
  }
  setShippingMethodsOnCart(
    input: {cart_id: $cartId, shipping_methods: [{carrier_code: $carrierCode, method_code: $methodCode}]}
  ) {
    cart {
      id
    }
  }
  setBillingAddressOnCart(
    input: {cart_id: $cartId, billing_address: {address: $billingAddress}}
  ) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiSetCheckoutFastFlowCartMutationResponse,
  Types.MagentoApiSetCheckoutFastFlowCartMutationVariables
>;
export const SetPaymentMethodOnCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation setPaymentMethodOnCart($cartId: String!, $code: String!) {
  setPaymentMethodOnCart(input: {cart_id: $cartId, payment_method: {code: $code}}) {
    cart {
      selected_payment_method {
        code
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiSetPaymentMethodOnCartMutationResponse,
  Types.MagentoApiSetPaymentMethodOnCartMutationVariables
>;
export const SetShippingAddressesOnCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation setShippingAddressesOnCart($cartId: String!, $address: CartAddressInput!) {
  setShippingAddressesOnCart(
    input: {cart_id: $cartId, shipping_addresses: [{address: $address}]}
  ) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiSetShippingAddressesOnCartMutationResponse,
  Types.MagentoApiSetShippingAddressesOnCartMutationVariables
>;
export const SetShippingAddressesOnCartByAddressIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation setShippingAddressesOnCartByAddressId($cartId: String!, $customer_address_id: Int!) {
  setShippingAddressesOnCart(
    input: {cart_id: $cartId, shipping_addresses: [{customer_address_id: $customer_address_id}]}
  ) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiSetShippingAddressesOnCartByAddressIdMutationResponse,
  Types.MagentoApiSetShippingAddressesOnCartByAddressIdMutationVariables
>;
export const SetShippingAddressesOnCartWithMethodsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation setShippingAddressesOnCartWithMethods($cartId: String!, $address: CartAddressInput!) {
  setShippingAddressesOnCart(
    input: {cart_id: $cartId, shipping_addresses: [{address: $address}]}
  ) {
    cart {
      shipping_addresses {
        available_shipping_methods {
          amount {
            currency
            value
          }
          available
          disable_for_subscription
          carrier_code
          carrier_title
          method_code
          method_title
          description
          estimated_delivery_time
        }
        selected_shipping_method {
          amount {
            currency
            value
          }
          carrier_code
          method_code
          method_title
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiSetShippingAddressesOnCartWithMethodsMutationResponse,
  Types.MagentoApiSetShippingAddressesOnCartWithMethodsMutationVariables
>;
export const SetShippingMethodsOnCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation setShippingMethodsOnCart($cartId: String!, $carrierCode: String!, $methodCode: String!) {
  setShippingMethodsOnCart(
    input: {cart_id: $cartId, shipping_methods: [{carrier_code: $carrierCode, method_code: $methodCode}]}
  ) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiSetShippingMethodsOnCartMutationResponse,
  Types.MagentoApiSetShippingMethodsOnCartMutationVariables
>;
export const UpdateCartItemQuantityDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation updateCartItemQuantity($cartId: String!, $cartItemId: Int!, $quantity: Float!) {
  updateCartItems(
    input: {cart_id: $cartId, cart_items: [{cart_item_id: $cartItemId, quantity: $quantity}]}
  ) {
    cart {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiUpdateCartItemQuantityMutationResponse,
  Types.MagentoApiUpdateCartItemQuantityMutationVariables
>;
export const UpdateCustomerAddressDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation updateCustomerAddress($addressId: Int!, $address: CustomerAddressInput!) {
  updateCustomerAddress(id: $addressId, input: $address) {
    city
    company
    country_code
    country_id
    default_billing
    default_shipping
    firstname
    id
    lastname
    middlename
    postcode
    prefix
    region {
      region
      region_code
      region_id
    }
    street
    suffix
    telephone
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiUpdateCustomerAddressMutationResponse,
  Types.MagentoApiUpdateCustomerAddressMutationVariables
>;
export const UpdatePaymentMethodDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation updatePaymentMethod($orderId: String!, $methodCode: String!) {
  updatePaymentMethod(input: {order_id: $orderId, method_code: $methodCode}) {
    success
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiUpdatePaymentMethodMutationResponse,
  Types.MagentoApiUpdatePaymentMethodMutationVariables
>;
export const GetAvailablePaymentMethodsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getAvailablePaymentMethods($cartId: String!) {
  cart(cart_id: $cartId) {
    available_payment_methods {
      code
      title
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetAvailablePaymentMethodsQueryResponse,
  Types.MagentoApiGetAvailablePaymentMethodsQueryVariables
>;
export const GetBrandConsumablesMatrixDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBrandConsumablesMatrix($brandCode: String!) {
  getBrandConsumableMatrix(brandCode: $brandCode) {
    id
    code
    name
    brandIcon
    isNew
    brandLabel
    brandLabels {
      label
      language
    }
    productBrandOptionId
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetBrandConsumablesMatrixQueryResponse,
  Types.MagentoApiGetBrandConsumablesMatrixQueryVariables
>;
export const GetBrandConsumablesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBrandConsumables($brandCode: String!) {
  getBrandConsumableMatrix(brandCode: $brandCode) {
    id
    code
    name
    brandIcon
    brandLabel
    packagingFormats {
      id
      brandId
      label
      contentsType
      itemsPerPackage
      packagesPerBundle
      formatQuantity
      productTypeName
      icon
    }
    items {
      sku
      brandId
      packagingFormatId
      purchaseType
      flavorDetails {
        flavour
        flavour_label
        swatch_data
      }
      sortOrder
      isDefault
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetBrandConsumablesQueryResponse,
  Types.MagentoApiGetBrandConsumablesQueryVariables
>;
export const GetCartIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCartId($cartId: String!) {
  cart(cart_id: $cartId) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCartIdQueryResponse,
  Types.MagentoApiGetCartIdQueryVariables
>;
export const GetCartItemsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCartItems($cartId: String!) {
  cart(cart_id: $cartId) {
    available_free_gifts {
      sales_rule_id
      allowed_gift_products {
        id
        sku
        name
      }
      gift_qty_limit
      is_removable
    }
    items {
      id
      errors {
        code
        message
      }
      has_registration_consent
      product {
        id
        name
        sku
        subscription
        has_registration_consent
        trade_in
        type_id
        stock_status
        has_device
        is_discontinued
        subscription_format
        delivery_region_code
        region
        region_label
        promotionalOffers {
          code
          limit_qty
          eligible
          type
          skus
          description {
            title
            description
            hint
            label
          }
        }
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            fixed_product_taxes {
              label
              amount {
                value
                currency
              }
            }
          }
          maximum_price {
            discount {
              amount_off
              percent_off
            }
            fixed_product_taxes {
              label
              amount {
                value
                currency
              }
            }
          }
        }
        image {
          url
          label
        }
        short_description {
          html
        }
        flavor
        flavor_label
        enable_order_quantity_limit
        order_quantity_limit
        color_label
        categories {
          name
          uid
          store_locator_name
        }
        free_gifts {
          allowed_qty
          products {
            is_eligible
            eligibility_description
            product {
              name
              sku
              tooltip_info
              stock_status
              image {
                url
                label
              }
            }
          }
        }
        strength
        strength_details {
          name
          rating
        }
      }
      quantity
      gift_data {
        is_gift
        parent_gift_sku
        parent_gift_id
        is_gift_removable
      }
      prices {
        discounts {
          amount {
            currency
            value
          }
          label
        }
        price {
          currency
          value
        }
        row_total {
          currency
          value
        }
        row_total_including_tax {
          currency
          value
        }
        total_item_discount {
          currency
          value
        }
      }
      ... on ConfigurableCartItem {
        configured_variant {
          is_discontinued
        }
      }
      ... on BundleCartItem {
        bundle_options {
          id
          label
          type
          values {
            id
            label
            price
            quantity
            presentation_info {
              initial_price
              presentation_price
              product {
                stock_status
                tooltip_info
                is_discontinued
                small_image {
                  url
                }
                price_range {
                  maximum_price {
                    final_price {
                      currency
                      value
                    }
                    regular_price {
                      currency
                      value
                    }
                  }
                  minimum_price {
                    final_price {
                      currency
                      value
                    }
                    regular_price {
                      currency
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCartItemsQueryResponse,
  Types.MagentoApiGetCartItemsQueryVariables
>;
export const GetCartPricesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCartPrices($cartId: String!) {
  cart(cart_id: $cartId) {
    subscription_amount
    shipping_addresses {
      selected_shipping_method {
        amount {
          currency
          value
        }
      }
    }
    estimated_shipping_cost {
      carrier_code
      method_code
      method_title
      is_market_default
      amount {
        value
        currency
      }
    }
    applied_coupons {
      code
      label
    }
    applied_campaign {
      loyalty_discount_amount
      loyalty_discount_uuid
    }
    prices {
      grand_total {
        currency
        value
      }
      subtotal_excluding_tax {
        currency
        value
      }
      subtotal_including_tax {
        currency
        value
      }
      applied_taxes {
        amount {
          currency
          value
        }
        label
        rate
      }
      discounts {
        amount {
          currency
          value
        }
        label
        coupon_code
      }
    }
    total_after_trial {
      total {
        currency
        value
      }
      total_incl_tax {
        currency
        value
      }
      tax {
        currency
        value
      }
    }
    available_payment_methods {
      code
      title
    }
    minimum_payable_amount {
      currency
      value
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCartPricesQueryResponse,
  Types.MagentoApiGetCartPricesQueryVariables
>;
export const GetCartSelectedPaymentMethodDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCartSelectedPaymentMethod($cartId: String!) {
  cart(cart_id: $cartId) {
    selected_payment_method {
      purchase_order_number
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCartSelectedPaymentMethodQueryResponse,
  Types.MagentoApiGetCartSelectedPaymentMethodQueryVariables
>;
export const GetConsumablesMatrixDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getConsumablesMatrix {
  getConsumablesMatrix {
    packagingFormats {
      id
      label
      contentsType
      itemsPerPackage
      packagesPerBundle
      formatQuantity
      productTypeName
      icon
    }
    items {
      sku
      packagingFormatId
      purchaseType
      brandId
      flavorDetails {
        flavour
        flavour_label
        swatch_data
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetConsumablesMatrixQueryResponse,
  Types.MagentoApiGetConsumablesMatrixQueryVariables
>;
export const GetCountiesForProfileDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCountiesForProfile {
  countries {
    available_regions {
      id
      code
      name
    }
    full_name_english
    full_name_locale
    id
    three_letter_abbreviation
    two_letter_abbreviation
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCountiesForProfileQueryResponse,
  Types.MagentoApiGetCountiesForProfileQueryVariables
>;
export const GetCountriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCountries {
  countries {
    available_regions {
      id
      code
      name
    }
    full_name_english
    full_name_locale
    id
    three_letter_abbreviation
    two_letter_abbreviation
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCountriesQueryResponse,
  Types.MagentoApiGetCountriesQueryVariables
>;
export const GetCountryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCountry($id: String!) {
  country(id: $id) {
    id
    two_letter_abbreviation
    three_letter_abbreviation
    full_name_english
    full_name_locale
    available_regions {
      id
      code
      name
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCountryQueryResponse,
  Types.MagentoApiGetCountryQueryVariables
>;
export const GetCurrencyDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCurrency {
  currency {
    default_display_currency_code
    default_display_currency_symbol
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCurrencyQueryResponse,
  Types.MagentoApiGetCurrencyQueryVariables
>;
export const GetCustomerAddressesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerAddresses {
  customer {
    default_shipping
    addresses {
      region {
        region
        region_code
        region_id
      }
      id
      country_code
      city
      company
      telephone
      firstname
      lastname
      middlename
      postcode
      street
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerAddressesQueryResponse,
  Types.MagentoApiGetCustomerAddressesQueryVariables
>;
export const GetCustomerCartDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerCart {
  customerCart {
    id
    available_payment_methods {
      code
      title
    }
    is_trial_eligible
    can_apply_coupons
    applied_campaign {
      loyalty_discount_uuid
      loyalty_discount_points
      loyalty_discount_amount
    }
    additional_attributes {
      attribute_code
      value
    }
    free_shipping_threshold
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerCartQueryResponse,
  Types.MagentoApiGetCustomerCartQueryVariables
>;
export const GetCustomerCartIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerCartId {
  customerCart {
    id
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerCartIdQueryResponse,
  Types.MagentoApiGetCustomerCartIdQueryVariables
>;
export const GetCustomerCartOrderPricesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerCartOrderPrices($cartId: String!) {
  cart(cart_id: $cartId) {
    subscription_amount
    shipping_addresses {
      selected_shipping_method {
        amount {
          currency
          value
        }
      }
    }
    estimated_shipping_cost {
      carrier_code
      method_code
      method_title
      is_market_default
      amount {
        value
        currency
      }
    }
    applied_campaign {
      loyalty_discount_amount
      loyalty_discount_uuid
    }
    prices {
      grand_total {
        currency
        value
      }
      subtotal_including_tax {
        currency
        value
      }
      subtotal_excluding_tax {
        currency
        value
      }
      applied_taxes {
        amount {
          currency
          value
        }
        label
        rate
      }
      discounts {
        amount {
          currency
          value
        }
        label
        coupon_code
      }
    }
    minimum_payable_amount {
      currency
      value
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerCartOrderPricesQueryResponse,
  Types.MagentoApiGetCustomerCartOrderPricesQueryVariables
>;
export const GetCustomerCartPricesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerCartPrices($cartId: String!) {
  cart(cart_id: $cartId) {
    email
    shipping_addresses {
      selected_shipping_method {
        amount {
          currency
          value
        }
      }
    }
    items {
      product {
        sku
        special_price
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            fixed_product_taxes {
              label
              amount {
                value
                currency
              }
            }
          }
          maximum_price {
            discount {
              amount_off
              percent_off
            }
            fixed_product_taxes {
              label
              amount {
                value
                currency
              }
            }
          }
        }
        price_tiers {
          quantity
          discount {
            percent_off
            amount_off
          }
          final_price {
            value
            currency
          }
        }
        name
        id
        uid
      }
      uid
      quantity
      product {
        name
        sku
        price_tiers {
          quantity
          final_price {
            value
          }
          discount {
            amount_off
            percent_off
          }
        }
      }
      prices {
        price {
          value
        }
      }
    }
    prices {
      discounts {
        label
        amount {
          value
        }
      }
      subtotal_including_tax {
        value
      }
      subtotal_excluding_tax {
        value
      }
      applied_taxes {
        label
        amount {
          value
        }
      }
      grand_total {
        currency
        value
      }
    }
    total_including_trial {
      total {
        currency
        value
      }
      total_incl_tax {
        currency
        value
      }
      tax {
        currency
        value
      }
    }
    total_after_trial {
      total {
        currency
        value
      }
      total_incl_tax {
        currency
        value
      }
      tax {
        currency
        value
      }
    }
    available_payment_methods {
      code
      title
    }
    minimum_payable_amount {
      currency
      value
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerCartPricesQueryResponse,
  Types.MagentoApiGetCustomerCartPricesQueryVariables
>;
export const GetCustomerCouponsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerCoupons($cartId: String!) {
  cart(cart_id: $cartId) {
    applied_coupons {
      code
      label
    }
    can_apply_coupons
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerCouponsQueryResponse,
  Types.MagentoApiGetCustomerCouponsQueryVariables
>;
export const GetCustomerExportedOrderDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerExportedOrderDetails($number: String!) {
  customer {
    orders(filter: {number: {eq: $number}}) {
      items {
        id
        order_date
        status
        items {
          product_name
          selected_options {
            label
            value
          }
          quantity_ordered
          quantity_refunded
          quantity_canceled
          product_sale_price {
            value
            currency
          }
          product_sale_price_incl_tax {
            currency
            value
          }
          product_sku
        }
        shipping_address {
          firstname
          lastname
          street
          city
          country_code
          postcode
          telephone
        }
        billing_address {
          firstname
          lastname
          street
          city
          country_code
        }
        shipping_method
        shipments {
          tracking {
            number
          }
        }
        payment_methods {
          type
          name
          additional_data {
            name
            value
          }
        }
        total {
          subtotal {
            currency
            value
          }
          taxes {
            amount {
              currency
              value
            }
          }
          discounts {
            label
            amount {
              currency
              value
            }
          }
          total_shipping {
            currency
            value
          }
          grand_total {
            value
            currency
          }
        }
        invoices {
          url
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerExportedOrderDetailsQueryResponse,
  Types.MagentoApiGetCustomerExportedOrderDetailsQueryVariables
>;
export const GetCustomerOrderDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerOrder($orderNumber: String!) {
  customer {
    orders(filter: {number: {eq: $orderNumber}}, scope: WEBSITE) {
      items {
        ...CustomerOrderFragment
      }
    }
  }
}
    fragment CustomerOrderFragment on CustomerOrder {
  id
  carrier
  number
  order_date
  shipping_method
  shipping_method_code
  status
  items {
    ...CustomerOrderItemFragment
  }
  payment_methods {
    type
    name
    additional_data {
      name
      value
    }
  }
  additional_attributes {
    attribute_code
    value
  }
  billing_address {
    ...CustomerOrderBillingAddressFragment
  }
  shipping_address {
    ...CustomerOrderShippingAddressFragment
  }
  loyalty_info {
    loyalty_discount_amount
    loyalty_discount_points
    loyalty_discount_uuid
  }
  invoices {
    url
  }
  total {
    ...CustomerOrderTotalFragment
  }
  total_including_trial {
    total {
      currency
      value
    }
    total_incl_tax {
      currency
      value
    }
    tax {
      currency
      value
    }
  }
  total_after_trial {
    total {
      currency
      value
    }
    total_incl_tax {
      currency
      value
    }
    tax {
      currency
      value
    }
  }
}
fragment CustomerOrderItemFragment on OrderItemInterface {
  id
  product_name
  product_sku
  product_type
  quantity_ordered
  trade_in
  row_total {
    currency
    value
  }
  row_total_incl_tax {
    currency
    value
  }
  product_sale_price {
    currency
    value
  }
  product_sale_price_incl_tax {
    currency
    value
  }
  gift_data {
    is_gift
    parent_gift_sku
    parent_gift_id
  }
  product {
    ...CustomerOrderProductFragment
  }
  ... on BundleOrderItem {
    bundle_options {
      id
      label
      values {
        id
        product_name
        quantity
        presentation_info {
          initial_price
          presentation_price
          product {
            tooltip_info
            small_image {
              label
              url
            }
          }
        }
      }
    }
  }
}
fragment CustomerOrderProductFragment on ProductInterface {
  subscription
  subscription_format
  enable_order_quantity_limit
  order_quantity_limit
  description {
    html
  }
  short_description {
    html
  }
  categories {
    name
    uid
  }
  image {
    url
  }
  strength
  strength_details {
    name
    rating
  }
  price_range {
    ...CustomerOrderPriceRangeFragment
  }
}
fragment CustomerOrderPriceRangeFragment on PriceRange {
  minimum_price {
    regular_price {
      value
      currency
    }
    final_price {
      value
      currency
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
  maximum_price {
    discount {
      amount_off
      percent_off
    }
    fixed_product_taxes {
      label
      amount {
        value
        currency
      }
    }
  }
}
fragment CustomerOrderBillingAddressFragment on OrderAddress {
  city
  country_code
  firstname
  lastname
  postcode
  street
  telephone
  administrative_area_level_2
  sublocality_level_2
  premise
  neighborhood
  landmark
  building_number
  district
  region
  short_address
}
fragment CustomerOrderShippingAddressFragment on OrderAddress {
  city
  country_code
  firstname
  lastname
  postcode
  street
  telephone
  pickup_information
  administrative_area_level_2
  sublocality_level_2
  premise
  neighborhood
  landmark
  building_number
  district
  region
  short_address
}
fragment CustomerOrderTotalFragment on OrderTotal {
  discounts {
    amount {
      currency
      value
    }
    label
    coupon_code
  }
  grand_total {
    currency
    value
  }
  subtotal {
    currency
    value
  }
  subtotal_incl_tax {
    currency
    value
  }
  taxes {
    title
    rate
    amount {
      currency
      value
    }
  }
  total_shipping {
    currency
    value
  }
  total_refunded {
    currency
    value
  }
  total_tax {
    currency
    value
  }
}`) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerOrderQueryResponse,
  Types.MagentoApiGetCustomerOrderQueryVariables
>;
export const GetCustomerOrderDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerOrderDetails($number: String!, $scope: ScopeTypeEnum) {
  customer {
    orders(filter: {number: {eq: $number}}, scope: $scope) {
      items {
        id
        order_date
        website_code
        has_withdrawal
        withdrawal_id
        status
        status_reason {
          reason_code
          reason_message
        }
        items {
          id
          product {
            __typename
            color_label
            enable_order_quantity_limit
            order_quantity_limit
            hidden_sku
            subscription
            is_discontinued
            categories {
              name
              uid
            }
            image {
              url
            }
          }
          product_type
          product_name
          selected_options {
            label
            value
          }
          quantity_ordered
          quantity_refunded
          quantity_canceled
          row_total {
            currency
            value
          }
          row_total_incl_tax {
            currency
            value
          }
          product_sale_price {
            value
            currency
          }
          product_sale_price_incl_tax {
            currency
            value
          }
          product_sku
          gift_data {
            is_gift
            parent_gift_sku
            parent_gift_id
          }
          ... on BundleOrderItem {
            bundle_options {
              id
              label
              values {
                uid
                id
                product_name
                quantity
                presentation_info {
                  initial_price
                  presentation_price
                  product {
                    uid
                    id
                    tooltip_info
                    is_discontinued
                    small_image {
                      url
                    }
                  }
                }
              }
            }
          }
        }
        additional_attributes {
          attribute_code
          value
        }
        shipping_address {
          firstname
          lastname
          street
          city
          country_code
          postcode
          telephone
          pickup_information
          administrative_area_level_2
          sublocality_level_2
          premise
          neighborhood
          landmark
          building_number
          district
          region
          region_code
          region_id
        }
        billing_address {
          firstname
          lastname
          street
          city
          postcode
          country_code
          administrative_area_level_2
          sublocality_level_2
          premise
          neighborhood
          landmark
          building_number
          district
          region
          region_code
          region_id
        }
        shipping_method
        loyalty_info {
          loyalty_discount_amount
          loyalty_discount_points
          loyalty_discount_uuid
        }
        shipments {
          tracking {
            carrier
            number
            track_url
          }
        }
        payment_methods {
          type
          name
          method_code
          additional_data {
            name
            value
          }
        }
        total {
          subtotal {
            currency
            value
          }
          subtotal_incl_tax {
            currency
            value
          }
          taxes {
            title
            rate
            amount {
              currency
              value
            }
          }
          discounts {
            label
            amount {
              currency
              value
            }
          }
          total_shipping {
            currency
            value
          }
          total_refunded {
            currency
            value
          }
          total_after_refund {
            currency
            value
          }
          grand_total {
            value
            currency
          }
        }
        total_after_trial {
          total {
            currency
            value
          }
          total_incl_tax {
            currency
            value
          }
          tax {
            currency
            value
          }
        }
        invoices {
          url
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerOrderDetailsQueryResponse,
  Types.MagentoApiGetCustomerOrderDetailsQueryVariables
>;
export const GetCustomerOrdersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerOrders($filter: CustomerOrdersFilterInput) {
  customer {
    orders(filter: $filter) {
      items {
        id
        status
        shipping_method
        carrier
        order_date
        items {
          id
          product_name
          quantity_shipped
          quantity_refunded
          quantity_canceled
          row_total_incl_tax {
            currency
            value
          }
        }
        number
        total {
          grand_total {
            currency
            value
          }
          subtotal {
            currency
            value
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerOrdersQueryResponse,
  Types.MagentoApiGetCustomerOrdersQueryVariables
>;
export const GetCustomerOrdersAllStoresDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerOrdersAllStores {
  customer {
    orders(scope: GLOBAL) {
      items {
        id
        number
        status
        created_at
        store_code
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerOrdersAllStoresQueryResponse,
  Types.MagentoApiGetCustomerOrdersAllStoresQueryVariables
>;
export const GetCustomerOrdersCountDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerOrdersCount($scope: ScopeTypeEnum) {
  customer {
    orders(scope: $scope) {
      total_count
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerOrdersCountQueryResponse,
  Types.MagentoApiGetCustomerOrdersCountQueryVariables
>;
export const GetCustomerOrdersPaginationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerOrdersPagination($filter: CustomerOrdersFilterInput, $currentPage: Int, $sort: CustomerOrderSortInput, $scope: ScopeTypeEnum, $order_type: OrderTypeEnum) {
  customer {
    orders(
      filter: $filter
      currentPage: $currentPage
      sort: $sort
      scope: $scope
      order_type: $order_type
    ) {
      page_info {
        current_page
        total_pages
      }
      items {
        id
        status
        shipping_method
        carrier
        order_date
        store_code
        website_code
        items {
          id
          product_name
          quantity_shipped
          product_subscription
        }
        payment_methods {
          type
          name
        }
        number
        shipments {
          tracking {
            track_url
          }
        }
        total {
          grand_total {
            currency
            value
          }
          subtotal {
            currency
            value
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerOrdersPaginationQueryResponse,
  Types.MagentoApiGetCustomerOrdersPaginationQueryVariables
>;
export const GetCustomerOrdersStatusesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getCustomerOrdersStatuses($filter: CustomerOrdersFilterInput) {
  customer {
    orders(filter: $filter) {
      items {
        id
        status
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetCustomerOrdersStatusesQueryResponse,
  Types.MagentoApiGetCustomerOrdersStatusesQueryVariables
>;
export const GetLastCustomerOrderDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getLastCustomerOrder {
  LastCustomerOrder {
    shipping_method_code
    payment_methods {
      type
      method_code
    }
    additional_attributes {
      attribute_code
      value
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetLastCustomerOrderQueryResponse,
  Types.MagentoApiGetLastCustomerOrderQueryVariables
>;
export const GetOrderAttributesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getOrderAttributes {
  getOrderAttributes {
    code
    label
    input_type
    data_type
    is_required
    min_length
    max_length
    validate_regex
    value
    description
    placeholder
    placement
    sort_order
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetOrderAttributesQueryResponse,
  Types.MagentoApiGetOrderAttributesQueryVariables
>;
export const GetOrderDeliveryLimitsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getOrderDeliveryLimits {
  getOrderDeliveryLimits {
    mode
    limits {
      id
      country_id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetOrderDeliveryLimitsQueryResponse,
  Types.MagentoApiGetOrderDeliveryLimitsQueryVariables
>;
export const GetProductImageDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getProductImage($sku: String!) {
  products(filter: {sku: {eq: $sku}}) {
    items {
      sku
      image {
        url
      }
      small_image {
        url
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetProductImageQueryResponse,
  Types.MagentoApiGetProductImageQueryVariables
>;
export const GetProductImageDescriptionDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getProductImageDescription($sku: [String]!) {
  products(filter: {sku: {in: $sku}}) {
    items {
      sku
      description {
        html
      }
      image {
        url
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetProductImageDescriptionQueryResponse,
  Types.MagentoApiGetProductImageDescriptionQueryVariables
>;
export const GetProductPriceDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getProductPrice($sku: String!, $quantity: Int!) {
  getProductPrice(sku: $sku, quantity: $quantity) {
    maximum_price {
      final_price {
        currency
        value
      }
      regular_price {
        currency
        value
      }
    }
    minimum_price {
      final_price {
        currency
        value
      }
      regular_price {
        currency
        value
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetProductPriceQueryResponse,
  Types.MagentoApiGetProductPriceQueryVariables
>;
export const GetProductsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getProducts($sku: [String], $pageSize: Int) {
  currency {
    base_currency_code
    base_currency_symbol
  }
  products(filter: {sku: {in: $sku}}, pageSize: $pageSize) {
    aggregations {
      attribute_code
      label
      options {
        count
        label
        value
      }
    }
    items {
      sku
      __typename
      id
      name
      stock_status
      flavor
      flavor_label
      product_brand
      color
      subtitle
      product_disclaimer
      categories {
        name
      }
      flavour_details {
        name
        description
        attributes {
          id
          name
          sort_order
          value
        }
      }
      thumbnail {
        url
      }
      media_gallery {
        label
        url
        ... on ProductImage {
          role
        }
        ... on ProductVideo {
          video_content {
            video_title
            video_url
          }
        }
      }
      price_tiers {
        quantity
        discount {
          percent_off
          amount_off
        }
        final_price {
          value
          currency
        }
        total_price {
          value
          currency
        }
        label
      }
      price_range {
        minimum_price {
          final_prices {
            value
            currency
            multiplier
          }
          final_price {
            value
            currency
          }
          regular_price {
            value
            currency
          }
          discount {
            percent_off
          }
        }
      }
      ... on ConfigurableProduct {
        variants {
          product {
            sku
            name
            color
            stock_status
            flavor
            color_label
            subtitle
            product_disclaimer
            categories {
              name
            }
            price_range {
              minimum_price {
                final_price {
                  value
                  currency
                }
                regular_price {
                  value
                  currency
                }
                discount {
                  percent_off
                }
              }
            }
          }
        }
      }
      ... on BundleProduct {
        items {
          option_id
          title
          required
          type
          qty
          __typename
          sku
          all_options {
            id
            label
            qty
            quantity
            is_default
            product {
              id
              name
              sku
              flavor
              flavor_label
              product_brand
              stock_status
              color_label
              subtitle
              flavour_details {
                name
                description
                attributes {
                  id
                  name
                  sort_order
                  value
                }
              }
              thumbnail {
                url
              }
              media_gallery {
                label
                url
                ... on ProductImage {
                  role
                }
                ... on ProductVideo {
                  video_content {
                    video_title
                    video_url
                  }
                }
              }
              categories {
                name
              }
              price_range {
                minimum_price {
                  final_price {
                    value
                    currency
                  }
                  regular_price {
                    value
                    currency
                  }
                  discount {
                    percent_off
                  }
                }
              }
              __typename
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetProductsQueryResponse,
  Types.MagentoApiGetProductsQueryVariables
>;
export const GetProductsEssentialsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getProductsEssentials($sku: [String], $pageSize: Int) {
  currency {
    base_currency_code
    base_currency_symbol
  }
  products(filter: {sku: {in: $sku}}, pageSize: $pageSize) {
    items {
      sku
      __typename
      id
      name
      short_description {
        html
      }
      thumbnail {
        url
      }
      url_key
      stock_status
      province
      strength
      strength_details {
        name
        rating
      }
      ... on ConfigurableProduct {
        configurable_options {
          values {
            label
            swatch_data {
              value
            }
          }
        }
        variants {
          product {
            sku
            name
            stock_status
          }
        }
      }
      ... on BundleProduct {
        items {
          __typename
          sku
          options {
            id
            label
            product {
              id
              name
              sku
              stock_status
              __typename
            }
          }
        }
      }
    }
  }
  products_prices(filter: {sku: {in: $sku}}, pageSize: $pageSize) {
    total_count
    items {
      sku
      stock_status
      price_range {
        minimum_price {
          final_price {
            value
          }
          regular_price {
            value
          }
          discount {
            percent_off
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetProductsEssentialsQueryResponse,
  Types.MagentoApiGetProductsEssentialsQueryVariables
>;
export const GetPromoGiftInfoDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getPromoGiftInfo($sku: [String]!) {
  products(filter: {sku: {in: $sku}}) {
    items {
      sku
      image {
        url
      }
      ... on BundleProduct {
        items {
          options {
            uid
            is_default
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetPromoGiftInfoQueryResponse,
  Types.MagentoApiGetPromoGiftInfoQueryVariables
>;
export const GetPromotionalOffersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getPromotionalOffers($sku: [String], $pageSize: Int) {
  products(filter: {sku: {in: $sku}}, pageSize: $pageSize) {
    items {
      sku
      promotionalOffers {
        code
        limit_qty
        eligible
        potentially_eligible
        type
        skus
        description {
          title
          description
          hint
          label
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetPromotionalOffersQueryResponse,
  Types.MagentoApiGetPromotionalOffersQueryVariables
>;
export const GetShippingMethodsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getShippingMethods($cartId: String!) {
  cart(cart_id: $cartId) {
    shipping_addresses {
      available_shipping_methods {
        amount {
          currency
          value
        }
        available
        disable_for_subscription
        carrier_code
        carrier_title
        method_code
        method_title
        description
        estimated_delivery_time
      }
      selected_shipping_method {
        amount {
          currency
          value
        }
        carrier_code
        method_code
        method_title
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetShippingMethodsQueryResponse,
  Types.MagentoApiGetShippingMethodsQueryVariables
>;
export const GetSticksMatrixDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getSticksMatrix {
  getSticksMatrix {
    single_packs {
      onetime {
        flavour
        flavour_label
        sku
        swatch_data
      }
      subscription {
        flavour
        flavour_label
        sku
        swatch_data
      }
    }
    cartons {
      onetime {
        flavour
        flavour_label
        sku
        swatch_data
      }
      subscription {
        flavour
        flavour_label
        sku
        swatch_data
      }
    }
    mix_n_match {
      onetime {
        sku
      }
      subscription {
        sku
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetSticksMatrixQueryResponse,
  Types.MagentoApiGetSticksMatrixQueryVariables
>;
export const GetStockStatusesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getStockStatuses($sku: [String], $pageSize: Int) {
  products(filter: {sku: {in: $sku}}, pageSize: $pageSize) {
    items {
      sku
      __typename
      stock_status
      ... on ConfigurableProduct {
        variants {
          product {
            sku
            name
            stock_status
          }
        }
      }
      ... on BundleProduct {
        items {
          option_id
          title
          __typename
          sku
          all_options {
            id
            label
            product {
              id
              name
              sku
              stock_status
              __typename
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetStockStatusesQueryResponse,
  Types.MagentoApiGetStockStatusesQueryVariables
>;
export const GetStoreConfigDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getStoreConfig {
  storeConfig {
    id
    store_code
    store_group_code
    website_code
    is_order_limit_enabled
    is_age_verification_enabled
    age_verification_mode
    is_free_gifts_enabled
    gift_basket_quantity_limitation
    order_limit_value
    base_currency_code
    postcode_validation_enabled
    postcode_is_required
    postcode_max_length
    postcode_min_length
    postcode_validate_regex
    allow_empty_firstname
    cartons_limit_value
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetStoreConfigQueryResponse,
  Types.MagentoApiGetStoreConfigQueryVariables
>;
export const GetUrlKeysDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getUrlKeys($sku: String!) {
  products(filter: {sku: {eq: $sku}}) {
    items {
      url_key
      categories {
        url_path
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetUrlKeysQueryResponse,
  Types.MagentoApiGetUrlKeysQueryVariables
>;
export const GetXSellingPopupDocument = /*#__PURE__*/ new TypedDocumentString(`
    query getXSellingPopup($cartId: String!) {
  cart(cart_id: $cartId) {
    cross_sell_popup {
      id
      max_displays_per_session
      priority
      offer {
        sku
        price {
          currency
          value
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  Types.MagentoApiGetXSellingPopupQueryResponse,
  Types.MagentoApiGetXSellingPopupQueryVariables
>;
